



















































































































import { Component, Vue } from "vue-property-decorator";
import { PlayerExportModel } from "@/services/reports/types";
import { exportPlayerReport } from "@/services/reports/reportsService";

@Component
export default class PlayerReportExportModal extends Vue {
    model = {
        playerName: true,
        playerId: true,
        playerFolderPath: true,
        pcName: false,
        playerType: false,
        playerVersion: false,
        windowsVersion: false,
        macAddress: false,
        serialNumber: false,
        diskSpace: false,
        ipAddresses: false,
        activationDate: false,
        lastActiveDate: false,
        averageUptime: false,
        solutionName: false,
        solutionFolderPath: false,
        designName: false,
        powerPlanName: false,
        contractNumber: false,
        playerDescription: false
    } as PlayerExportModel;

    isBusy = false;
    error = false;

    open(sortDesc: boolean, sortBy: string, playerIds: string[]) {
        this.model.sortDesc = sortDesc;
        this.model.sort = sortBy;
        this.model.ids = playerIds;
        this.$bvModal.show("modal-export");
    }

    exportReport() {
        this.isBusy = true;
        exportPlayerReport(this.model).then(response => {
            this.$bvModal.hide("modal-export");
            this.isBusy = false;
            this.error = false;
        }).catch(() => {
            this.isBusy = false;
            this.error = true;
        });
    }

    resetLocalState() {
        this.isBusy = false;
        this.error = false;
    }

    goToSupportPage() {
        this.$router.push({ path: "/support" });
    }

    select(value: boolean) {
        this.model.pcName = value;
        this.model.playerType = value;
        this.model.playerVersion = value;
        this.model.windowsVersion = value;
        this.model.macAddress = value;
        this.model.serialNumber = value;
        this.model.diskSpace = value;
        this.model.ipAddresses = value;
        this.model.activationDate = value;
        this.model.lastActiveDate = value;
        this.model.averageUptime = value;
        this.model.solutionName = value;
        this.model.solutionFolderPath = value;
        this.model.designName = value;
        this.model.powerPlanName = value;
        this.model.contractNumber = value;
        this.model.playerDescription = value;
    }
}
